// We need to initialize common page elements,
// as this entrypoint isn't initialized by the main application.js
import "entry/common"

import $ from "jquery"
import { isSessionActive } from "lib/currentUser/session"
import { getWindowLocation, setWindowLocation } from "lib/windowLocation"
import { initializeCommonPageElements } from "pages/common"

const showMoreExperts = (event) => {
  event.preventDefault()
  $(".expert-authors").addClass("show-all")
}

const clickHandheldTab = (event) => {
  event.preventDefault()
  const section = $(event.target).attr("href")
  $("#tabbed-navigation a.active").removeClass("active")
  $(event.target).addClass("active")
  switch (section) {
    default:
      $(".topic-page").removeClass("sm-display-contributors sm-display-links")
      $(".topic-page").addClass("sm-display-articles")
      break
    case "#contributors":
      $(".topic-page").removeClass("sm-display-articles sm-display-links")
      $(".topic-page").addClass("sm-display-contributors")
      break
    case "#links":
      $(".topic-page").removeClass("sm-display-articles sm-display-contributors")
      $(".topic-page").addClass("sm-display-links")
      break
  }
}

const setTopicFollowedState = (following) => {
  $(".actions .follow-link")
    .toggleClass("followed", following)
    .toggleClass("not-followed", !following)
}

let followStateRequest = null

const fetchTopicFollowedState = () => {
  followStateRequest = $.ajax({
    type: "GET",
    url: `${document.location.pathname}/following`,
    success: ({ following }) => setTopicFollowedState(following),
    failure: () => setTopicFollowedState(false),
  })
}

const toggleTopicFollow = (following) => (event) => {
  event.preventDefault()
  followStateRequest?.abort?.()
  $.ajax({
    type: "POST",
    url: $(event.currentTarget).data("url"),
    success: () => setTopicFollowedState(following),
    error: fetchTopicFollowedState,
  })
}

const initializeHandheldTabEvents = () => {
  $("#tabbed-navigation a").on("click", clickHandheldTab)
  $(".expert-authors .more a").on("click", showMoreExperts)
}

const initializeFollowEvents = () => {
  if (!isSessionActive()) {
    $(".actions .follow-link button").on("click", (event) => {
      event.preventDefault()
      setWindowLocation(`/sign_in?return_to=${encodeURIComponent(getWindowLocation().pathname)}`)
    })
    setTopicFollowedState(false)
    return
  }

  fetchTopicFollowedState()
  $(".actions .follow-link .follow").on("click", toggleTopicFollow(true))
  $(".actions .follow-link .unfollow").on("click", toggleTopicFollow(false))
}

async function initialize() {
  initializeCommonPageElements()
  initializeHandheldTabEvents()
  initializeFollowEvents()
}

TC.EntrypointInitializer = initialize
